import { render } from "./WinnerDetailDialog.vue?vue&type=template&id=ae5d85b4"
import script from "./WinnerDetailDialog.vue?vue&type=script&lang=js"
export * from "./WinnerDetailDialog.vue?vue&type=script&lang=js"

import "./WinnerDetailDialog.vue?vue&type=style&index=0&id=ae5d85b4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__